import {useQuery} from "@tanstack/react-query";
import {getOrganizations} from "../utils/Api";
import {TableState, tableStateToParams} from "../components/EnhancedTable/EnhancedTable";

export const useOrganizationList = (tableState: TableState) => {
    const queryParams = tableStateToParams(tableState);
    return useQuery(["organizationsList", queryParams], async () => {
        return await getOrganizations(queryParams);
    });
}

export const useOrganizationChoices = () => {
    const queryParams = "?disablePagination=true"
    return useQuery(["organizationChoices", queryParams], async () => {
        return await getOrganizations(queryParams);
    });
}